import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export const YupCoupon = () => {
  //page hook
  const { t } = useTranslation();

  return {
    familyName: Yup.string().required(
      t("validation.required", {
        familyName: t("page.familyName"),
      })
    ),
    programName: Yup.string().required(
      t("validation.required", {
        programName: t("page.programName"),
      })
    ),
    serviceName: Yup.string().required(
      t("validation.required", {
        serviceName: t("page.serviceName"),
      })
    ),
    noOfCoupons: Yup.string().required(
      t("validation.required", {
        noOfCoupons: t("page.noOfCoupons"),
      })
    ),
  };
};
